import { reactive } from "vue";

export default {
  state: reactive({
    submissionValidationErrors: {},
  }),

  /**
   * getter method
   */
  getSubmissionValidationErrors() {
    return this.state.submissionValidationErrors;
  },
  /**
   * actions method
   */
  resetSubmitErrors() {
    this.state.submissionValidationErrors = {};
  },
  removeSubmitErrors(errorName) {
    const newErrors = Object.assign({}, this.state.submissionValidationErrors);
    delete newErrors[errorName];
    this.state.submissionValidationErrors = newErrors;
  },
  setSubmissionValidationErrors(submissionValidationErrors) {
    this.state.submissionValidationErrors = submissionValidationErrors;
  },
  addSubmissionValidationErrors(validationError) {
    const newErrors = Object.assign({}, this.state.submissionValidationErrors);
    newErrors[validationError.errorName] = validationError.message;
    this.state.submissionValidationErrors = newErrors;
  },
};
